import { render, staticRenderFns } from "./Composite.vue?vue&type=template&id=674e280e"
import script from "./Composite.vue?vue&type=script&lang=js"
export * from "./Composite.vue?vue&type=script&lang=js"
import style0 from "./Composite.vue?vue&type=style&index=0&id=674e280e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports